import {
    Dialog,
    DialogActions,
    DialogTitle
} from "@mui/material";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormikActions from "../../../../commons/formik/FormikActions";
import FormikTextField from "../../../../commons/formik/FormikTextField";
import { StyledEmpresaTable } from "../../../../styled/Personal";

const initialValues = {
  cuit: "",
  razonsocial: "",
};

const validation = Yup.object({
  cuit: Yup.string()
    .matches(/^\d{2}\d{8}\d{1}$/, "El CUIT no es válido. Ingréselo sin guiones")
    .required("Campo obligatorio"),
  razonsocial: Yup.string().required("Campo obligatorio"),
});

const EmpresaForm = ({ handleSubmit, edit, handleClose, open, empresa }) => {

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>{edit ? "Editar" : "Agregar"} Empresa</DialogTitle>
      <Formik
        initialValues={empresa ? empresa : initialValues}
        validationSchema={validation}
        onSubmit={handleSubmit}
      >
        <Form>
          <StyledEmpresaTable.FormDialogContainer>
            <FormikTextField name="cuit" type="text" label="CUIT" />
            <FormikTextField
              name="razonsocial"
              type="text"
              label="Razón Social"
            />
          </StyledEmpresaTable.FormDialogContainer>
          <DialogActions>
            <FormikActions
              handleCancel={handleClose}
              submit="Agregar"
            ></FormikActions>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default EmpresaForm;
